import React from 'react';
import { ExternalLink } from 'lucide-react';
import { PAPER_APA, PAPER_TITLE, PAPER_URL } from '../constants/links';

const ContactTab: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Contact Information */}
      <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact & Feedback</h2>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Project Leads</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-900">Kianté Fernandez</p>
                </div>
                <a
                  href="https://kiantefernandez.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-600 hover:text-primary-700 transition-colors"
                >
                  kiantefernandez.com
                  <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium text-gray-900">Andrea Low</p>
                </div>
                <a
                  href="https://andrealow.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-primary-600 hover:text-primary-700 transition-colors"
                >
                  andrealow.net
                  <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Citation Information */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Citation</h2>

        <div className="space-y-4">
          <p className="text-gray-700 leading-relaxed">
            Survey Shield is described in &ldquo;{PAPER_TITLE}&rdquo;. If you
            use it in your research, please cite:
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <p className="font-mono text-sm text-gray-800 leading-relaxed">
              {PAPER_APA}
            </p>
          </div>

          <a
            href={PAPER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-primary-600 hover:text-primary-700 transition-colors text-sm font-medium"
          >
            Read the paper on SSRN
            <ExternalLink className="w-4 h-4 ml-1" />
          </a>

          <p className="text-sm text-gray-600 mt-4">
            This project is funded by the Morrison Center for Marketing Studies at UCLA Anderson School of Management.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactTab;
